export const EXCHANGE_TYPES = {
  CASH_ONLY: "cash_only",
  CASH_OR_TRADE: "cash_or_trade",
  TRADE_ONLY: "trade_only",
  FREE: "free",
};

export const EXCHANGE_TYPE_OPTIONS = [
  { value: EXCHANGE_TYPES.CASH_ONLY, label: "Cash only" },
  { value: EXCHANGE_TYPES.CASH_OR_TRADE, label: "Cash or trade" },
  { value: EXCHANGE_TYPES.TRADE_ONLY, label: "Trade only" },
  { value: EXCHANGE_TYPES.FREE, label: "Free" },
];

export const BARTER_CATEGORY_OPTIONS = [
  { value: "farm_goods", label: "Farm goods" },
  { value: "plants_seeds_starts", label: "Plants, seeds, starts" },
  { value: "eggs_meat_dairy", label: "Eggs, meat, dairy" },
  { value: "hay_feed", label: "Hay or feed" },
  { value: "equipment_tools", label: "Equipment or tools" },
  { value: "labor_help", label: "Labor or help" },
  { value: "services", label: "Services" },
  { value: "livestock", label: "Livestock" },
  { value: "handmade_goods", label: "Handmade goods" },
  { value: "other", label: "Other" },
];

export const WANTED_CATEGORY_OPTIONS = [
  { value: "farm_goods", label: "Farm goods" },
  { value: "plants_seeds_starts", label: "Plants, seeds, starts" },
  { value: "livestock", label: "Livestock" },
  { value: "equipment_tools_parts", label: "Equipment, tools, parts" },
  { value: "hay_feed", label: "Hay or feed" },
  { value: "labor_help", label: "Labor or help" },
  { value: "services", label: "Services" },
  { value: "land", label: "Land" },
  { value: "handmade_goods", label: "Handmade goods" },
  { value: "other", label: "Other" },
];

export const WANT_AD_URGENCY_OPTIONS = [
  { value: "just_browsing", label: "Just browsing" },
  { value: "soon", label: "Soon" },
  { value: "urgent", label: "Urgent" },
];

export const DEFAULT_BARTER_FIELDS = {
  exchangeType: EXCHANGE_TYPES.CASH_ONLY,
  barterEnabled: false,
  barterOpenToAnything: false,
  barterCategories: [],
  barterNotes: "",
};

export const getExchangeTypeLabel = (value) =>
  EXCHANGE_TYPE_OPTIONS.find((option) => option.value === value)?.label || "Cash only";

export const getBarterCategoryLabel = (value) =>
  BARTER_CATEGORY_OPTIONS.find((option) => option.value === value)?.label || value;

export const getWantedCategoryLabel = (value) =>
  WANTED_CATEGORY_OPTIONS.find((option) => option.value === value)?.label || value;

export const normalizeBarterFields = (source = {}) => {
  const exchangeType = Object.values(EXCHANGE_TYPES).includes(source.exchangeType)
    ? source.exchangeType
    : EXCHANGE_TYPES.CASH_ONLY;
  const canTrade =
    exchangeType === EXCHANGE_TYPES.CASH_OR_TRADE ||
    exchangeType === EXCHANGE_TYPES.TRADE_ONLY;

  return {
    exchangeType,
    barterEnabled: canTrade,
    barterOpenToAnything: canTrade ? source.barterOpenToAnything === true : false,
    barterCategories: canTrade && Array.isArray(source.barterCategories) ? source.barterCategories : [],
    barterNotes: canTrade ? String(source.barterNotes || "").trim() : "",
  };
};

export const buildBarterPayload = (fields = {}) => normalizeBarterFields(fields);

export const isOpenToTrade = (listing = {}) => normalizeBarterFields(listing).barterEnabled;

export const getExchangeBadges = (listing = {}) => {
  const normalized = normalizeBarterFields(listing);
  const badges = [getExchangeTypeLabel(normalized.exchangeType)];

  if (normalized.barterEnabled) {
    badges.push(normalized.barterOpenToAnything ? "Open to Any Fair Trade" : "Willing to Trade");
  }

  return badges;
};

export const getTradeMessageDraft = (listing = {}) => {
  const normalized = normalizeBarterFields(listing);

  if (normalized.exchangeType === EXCHANGE_TYPES.TRADE_ONLY) {
    return "Hi, I'm interested in this trade listing. I can offer:";
  }

  if (normalized.barterEnabled) {
    return "Hi, I'm interested in this listing. Would you consider a trade? I can offer:";
  }

  return "";
};
